import request from '@/utils/request'
//import getBrowserLang from '@/i18n/index'

// 获取网关列表
export function getGatewayList(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/gateway/list',
    method: 'post',
    data
  })
}

// 新增网关
export function addGateway(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/gateway/add',
    method: 'post',
    data
  })
}

// 更新网关
export function updateGateway(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/gateway/edit',
    method: 'post',
    data
  })
}

// 删除网关
export function deleteGateway(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: `/api/gateway/delete`,
    method: 'post',
    data
  })
}